import { render, staticRenderFns } from "./UtilityRates.vue?vue&type=template&id=495968c4&scoped=true"
import script from "./UtilityRates.vue?vue&type=script&lang=js"
export * from "./UtilityRates.vue?vue&type=script&lang=js"
import style0 from "./UtilityRates.vue?vue&type=style&index=0&id=495968c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495968c4",
  null
  
)

export default component.exports